import { useState } from 'react';

export const modalStateHook = () => {
  const useModalState = (initialState = false) => {
    const [isVisible, setIsVisible] = useState(initialState);
    const open = () => setIsVisible(true);
    const close = () => setIsVisible(false);
    return { isVisible, open, close };
  };

  return { useModalState };
};
